import * as React from 'react';

import {
  Chip,
  Tooltip,
} from '@mui/material';

const statusOptions = {
  Incomplete: {
    color: 'error',
    variant: 'outlined',
    label: 'Incomplete',
  },
  Unset: {
    color: 'secondary',
    label: 'No Records',
    explanation: 'Add a previous completed task or schedule the next task to start tracking this reminder.',
  },
  Unscheduled: {
    color: 'secondary',
    variant: 'outlined',
    label: 'Unscheduled',
  },
  PastDue: {
    color: 'error',
    label: 'Past Due',
  },
  ScheduleMiss: {
    color: 'warning',
    label: 'At Risk',
    explanation: 'The next task is scheduled beyond the reminder date plus a 10% grace period.',
  },
  Scheduled: {
    color: 'primary',
    label: 'On Track & Scheduled',
  },
};

export const getReminderStatusOption = (status) => statusOptions[status] || { label: 'Status unavailable' };

export const getChipForStatus = (tagReminder, size = 'small') => {
  const option = getReminderStatusOption(tagReminder.status);
  const chipSize = size === 'large'
    ? 'medium'
    : size;
  const chip = <Chip color={option.color} variant={option.variant} label={option.label} size={chipSize} />;
  if (option.explanation) {
    return <Tooltip title={option.explanation}>{chip}</Tooltip>;
  }
  return chip;
};
